export enum CarStatus {
  ParkingLot = "ParkingLot", // штрафстоянка
  IsUsed = "IsUsed",
  Broken = "Broken",
}

export const localizationCarStatus: Record<CarStatus, string> = {
  [CarStatus.ParkingLot]: "ШТРАФСТОЯНКА",
  [CarStatus.IsUsed]: "ИСПОЛЬЗУЕТСЯ",
  [CarStatus.Broken]: "СЛОМАНА",
};
